<template>
    <div v-if="smartZoom.enabled" class="z-50">
        <transition name="fade-fast">
            <SmartZoomButton v-if="getArticles && getArticles.length > 0" :articles="getArticles"></SmartZoomButton>
        </transition>
        <transition name="fade">
            <SmartZoomModal v-if="smartZoom.visible" :articles="getArticles"></SmartZoomModal>
        </transition>
    </div>
</template>

<script>
'use strict';

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import SmartZoomModal from './SmartZoomModal.vue';
import SmartZoomButton from './SmartZoomButton.vue';
import isTouchDevice from '_shared_/js/utils/isTouchDevice.js';

export default {
    name: 'SmartZoom',
    components: {
        SmartZoomButton,
        SmartZoomModal,
    },
    computed: {
        ...mapState(['smartZoom', 'currentPageArticles', 'reader', 'articles']),
        ...mapGetters(['doublePageMode', 'currentPages']),
        getArticles() {
            if (!this.currentPages?.length || !this.articles) return [];

            // Get articles that are relevant to any of the currently visible pages
            return this.articles.filter(article =>
                this.currentPages.some(pageNumber => this.isArticleOnPage(article, pageNumber))
            );
        },
    },
    watch: {
        'smartZoom.visible'(isVisible) {
            if (isVisible) {
                this.pauseKeyboardNavigation();
                this.trackEvent({
                    action: 'SmartZoom - open',
                    trigger: '',
                    page: this.reader.pagination.current,
                    source: 'direct',
                });
            } else {
                this.resumeKeyboardNavigation();
            }
        },
    },
    mounted() {
        this.$bus.$on('showPointArticle', param => {
            this.$store.commit('setSharedArticle', {
                articleId: param.articleId,
                showed: false,
            });
            this.toggleSmartZoom();
        });
        document.addEventListener(isTouchDevice ? 'touchend' : 'click', e => {
            if (!e.target.classList.contains('articleLocation')) {
                return;
            }

            const articleId = e.target.dataset.articleId;
            const index = this.currentPageArticles?.findIndex(article => article.id === articleId) ?? -1;
            this.setCurrentArticleIndex({ currentArticleIndex: index });
            this.toggleSmartZoom();
        });
    },
    methods: {
        ...mapMutations([
            'toggleSmartZoom',
            'setCurrentArticleIndex',
            'pauseKeyboardNavigation',
            'resumeKeyboardNavigation',
        ]),
        ...mapActions(['trackEvent']),

        isArticleOnPage(article, pageNumber) {
            // Check if article starts, ends, or spans across the given page
            const startsOnPage = article.start_page === pageNumber;
            const endsOnPage = article.end_page === pageNumber;
            const spansAcrossPage = article.start_page < pageNumber && pageNumber < article.end_page;

            return startsOnPage || endsOnPage || spansAcrossPage;
        },
    },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
    z-index: 50;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
    z-index: 50;
}

.fade-fast-enter-active,
.fade-fast-leave-active {
    transition: opacity 0.25s;
    z-index: 50;
}
.fade-fast-enter,
.fade-fast-leave-to {
    opacity: 0;
    z-index: 50;
}
</style>
